<div class="label-value-input slider">
    <div class="element-label">
        <div class="input-label">All:</div>
        <div class="input-value-container"><input class="input-value" nbInput fieldSize="tiny" type="number" [(ngModel)]="valueAll"></div>
    </div>
    <div class="custom-slider element-value">
        <ngx-slider [options]="options" [formControl]="sliderControl"></ngx-slider>
    </div>
</div>
<div class="label-value-input slider">
    <div class="element-label">
        <div class="input-label">Top:</div><div class="input-value-container"><input class="input-value" nbInput fieldSize="tiny" type="number" [(ngModel)]="valueTop"></div>
    </div>
    <div class="element-label">
        <div class="input-label">Right:</div><div class="input-value-container"><input class="input-value" nbInput fieldSize="tiny" type="number" [(ngModel)]="valueRight"></div>
    </div>
    <div class="element-label">
        <div class="input-label">Bottom:</div><div class="input-value-container"><input class="input-value" nbInput fieldSize="tiny" type="number" [(ngModel)]="valueBottom"></div>
    </div>
    <div class="element-label">
        <div class="input-label">Left:</div><div class="input-value-container"><input class="input-value" nbInput fieldSize="tiny" type="number" [(ngModel)]="valueLeft"></div>
    </div>
</div>



